import { Injectable, signal } from '@angular/core';

export type Bounds = {
    left: number;
    top: number;
    right: number;
    bottom: number;
    width: number;
    height: number;
    horizontalCenter: number;
    verticalCenter: number;
};
export type Target = {
    id: string;
    bounds: Bounds;
    element: HTMLElement;
};

@Injectable({
    providedIn: 'root',
})
export class WebWidgetBoundaryService {
    public readonly widgetVerticalCenterId = signal<string | null>(null);
    public readonly widgetHorizontalCenterId = signal<string | null>(null);
    public readonly widgetTopId = signal<string | null>(null);
    public readonly widgetBottomId = signal<string | null>(null);
    public readonly widgetLeftId = signal<string | null>(null);
    public readonly widgetRightId = signal<string | null>(null);
    public readonly columnHorizontalCenterId = signal<string | null>(null);
    public readonly columnVerticalCenterId = signal<string | null>(null);

    private candidateTargetBoundsMap: Map<string, Bounds> = new Map();

    public removeTargetCandidate(widgetId: string): void {
        this.candidateTargetBoundsMap.delete(widgetId);
    }

    public getTargetCandidatesArray(): Target[] {
        return Array.from(this.candidateTargetBoundsMap.entries())
            .map(([key, item]) => ({
                id: key,
                bounds: item,
                element: document.getElementById(key),
            }))
            .filter((item) => !!item.element);
    }

    public updateTargetCandidate(widgetId: string, data: Bounds): void {
        this.candidateTargetBoundsMap.set(widgetId, data);
    }
}
